import styled from 'styled-components';

type WrapperProps = {
  height?: string;
  noclick?: boolean;
  tripItem?: boolean;
  alertItem?: boolean;
  alignLeft?: boolean;
};

const isDarkTheme = (theme: { colors: { text: string; white: string } }): boolean => (
  theme.colors.text === theme.colors.white
);

export const ListItemWrapper = styled.li<WrapperProps>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: ${({ tripItem, alertItem, alignLeft }) => {
    if (alignLeft) return 'flex-start';
    if (tripItem || alertItem) return 'flex-end';
    return 'space-between';
  }};
  gap: 12px;
  min-height: ${(props) => (props.height ? props.height : '84px')};
  padding: 16px 15px;

  border-radius: 12px;
  background-color: ${(props) => props.theme.colors.widget_background};
  /* Reserve border space so hover outline does not shift layout. */
  border: 1px solid transparent;
  box-sizing: border-box;

  cursor: ${(props) => (props.noclick ? 'default' : 'pointer')};

  width: 100%;
  position: relative;
  overflow: hidden;

  &:hover {
    background-color: ${(props) => (
    isDarkTheme(props.theme)
      ? props.theme.colors.widget_hover_background
      : props.theme.colors.widget_background
  )};
    border-color: ${(props) => (
    isDarkTheme(props.theme) ? 'transparent' : '#D0D7DD'
  )};
    box-shadow: ${(props) => (
    isDarkTheme(props.theme) ? 'none' : props.theme.shadows.dropdown
  )};

    .overview-container {
      background-color: ${(props) => (
    isDarkTheme(props.theme)
      ? props.theme.colors.widget_hover_background
      : props.theme.colors.widget_background
  )};
      transition: all 0.5s ease-in;
    }

    .overview-container .description .title {
      color: ${(props) => props.theme.colors.hover_accent};
      transition: all 0.2s ease-in;
    }

    .button-container i {
      padding-left: 6px;
      transition: all 0.2s ease-in;
    }

    transition: all 0.5s ease-in;
  }

  .tags-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    min-width: 0;
  }

  @media (max-width: 1024px) {
    gap: 10px;
    padding: 14px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;

    .tags-container {
      width: 100%;
    }
  }

  @media (max-width: 480px) {
    padding: 12px;
    gap: 8px;
  }
`;
